var exports = {
  "kL": "VideoPlayer.module__container___X3hyeV",
  "Ki": "VideoPlayer.module__video___X3hyeV",
  "ER": "VideoPlayer.module__videoHidden___X3hyeV",
  "mz": "VideoPlayer.module__seekPreviewVideo___X3hyeV",
  "IN": "VideoPlayer.module__posterOverlay___X3hyeV",
  "lW": "VideoPlayer.module__posterImage___X3hyeV",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___X3hyeV",
  "HT": "VideoPlayer.module__playOverlayButton___X3hyeV",
  "$Z": "VideoPlayer.module__controlsOverlay___X3hyeV",
  "hr": "VideoPlayer.module__progressBar___X3hyeV",
  "xu": "VideoPlayer.module__controlsRow___X3hyeV",
  "it": "VideoPlayer.module__controlsLeft___X3hyeV",
  "QE": "VideoPlayer.module__controlsCenter___X3hyeV",
  "BT": "VideoPlayer.module__controlsRight___X3hyeV",
  "sL": "VideoPlayer.module__playPauseIndicator___X3hyeV",
  "HA": "VideoPlayer.module__fillContainer___X3hyeV",
  "Y5": "VideoPlayer.module__fullscreen___X3hyeV",
};

module.exports = exports;
